import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { StandardList } from '../components/StandardList'
import { TagList } from '../components/TagList'
import { Layout } from '../components/Layout'
import { Page } from '../components/Page'
import { ContentAstViewer } from '../components/ContentViewer'

export const UserPageTemplate = props => {
  const { title, content, standards, tags } = props

  return (
    <Page title={title}>
      { content }
      <StandardList standards={standards} />
      <TagList tags={tags} />
    </Page>
  )
}

UserPageTemplate.propTypes = {
  title: PropTypes.string,
  content: PropTypes.object
}

const GatsbyDataMapTemplate = props => {
  const { data } = props
  const { userPage, standards, tags } = data
  const myStandards = Array.isArray(standards) ? standards.edges.map(({ node }) => node) : []
  const myTags = Array.isArray(tags) ? tags : []
  const { frontmatter, html, htmlAst } = userPage.edges[0].node
  const { title } = frontmatter
  // const content = <ContentViewer content={html} />
  const content = <ContentAstViewer content={htmlAst} />
  return (
    <Layout>
      <UserPageTemplate title={title} content={content} standards={myStandards} tags={myTags} />
    </Layout>
  )
}

GatsbyDataMapTemplate.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  pageResources: PropTypes.object,
  pageContext: PropTypes.object,
  data: PropTypes.object,
  content: PropTypes.any
}

export default GatsbyDataMapTemplate

export const query = graphql`
  query FindUserPage($id: String, $standardCodes: [String]){
    standards:allMarkdownRemark(
      filter:{
        fields:{
          code:{ 
            in:$standardCodes
            ne:null
          }
        }
      }
    ){
      edges{
        node{
          frontmatter{
            title
          }
          fields{
            code
          }
        }
      }
    }
    userPage:allMarkdownRemark(filter:{id:{eq:$id}}){
      edges{
        node{
          html
          htmlAst
          frontmatter{
            title
            date
            slug
            tags
          }
        }
      }
    }
  }
`
